module.exports = __webpack_public_path__ + "assets/vimeo.bd9b04d5.svg";